import { apiSlice } from '../../api';
import type {
  GetProviderFeeDTO,
  GetProviderFeesDTO,
  GetProviderFeesResult,
  GetProviderFeeResult,
  GetProviderDTO,
  GetProvidersResult,
  PutProviderFeesResult,
  PostProviderFeeDTO,
  PostProviderFeeResult,
  DeleteProviderFeeDTO,
  DeleteProviderFeeResult,
  PutProviderFeeDTO,
} from './types';

const providersEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getProviders: build.query<GetProviderFeesResult, GetProviderFeesDTO>({
      query: () => ({
        url: '/admin/v1/providers',
        method: 'GET',
      }),
      providesTags: ['Fees'],
    }),

    getProviderFees: build.query<GetProvidersResult, GetProviderDTO>({
      query: ({ provider }) => ({
        url: `/admin/v1/providers/${provider}/fees`,
        method: 'GET',
      }),
      providesTags: ['Fees'],
    }),

    getProviderFee: build.query<GetProviderFeeResult, GetProviderFeeDTO>({
      query: ({ fee_id, provider }) => ({
        url: `/admin/v1/providers/${provider}/fees/${fee_id}`,
        method: 'GET',
      }),
    }),

    postProviderFee: build.mutation<PostProviderFeeResult, PostProviderFeeDTO>({
      query: ({ body, provider }) => ({
        url: `/admin/v1/providers/${provider}/fees`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Fees'],
    }),

    deleteProviderFee: build.mutation<DeleteProviderFeeResult, DeleteProviderFeeDTO>({
      query: ({ fee_id, provider }) => ({
        url: `/admin/v1/providers/${provider}/fees/${fee_id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Fees'],
    }),

    putProviderFees: build.mutation<PutProviderFeesResult, PutProviderFeeDTO>({
      query: ({ body, provider, fee_id }) => ({
        url: `/admin/v1/providers/${provider}/fees/${fee_id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useDeleteProviderFeeMutation,
  useGetProviderFeesQuery,
  useGetProviderFeeQuery,
  useLazyGetProviderFeeQuery,
  useGetProvidersQuery,
  useLazyGetProviderFeesQuery,
  useLazyGetProvidersQuery,
  usePostProviderFeeMutation,
  usePutProviderFeesMutation,
} = providersEndpoints;

export type ProvidersController = typeof providersEndpoints;
